import { Controller } from "@hotwired/stimulus"

// This controller ensures GIFs are loaded efficiently
export default class extends Controller {
  connect() {
    // Force GIF to load only when the element is in viewport
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // Force reload the GIF to start playing from beginning
          const src = this.element.src
          this.element.src = ""
          this.element.src = src
          observer.unobserve(this.element)
        }
      })
    }, {
      threshold: 0.1 // Start loading when 10% of the element is visible
    })

    observer.observe(this.element)
  }
} 